<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardBody>
        <div class="col-md-6 float-left">
          <input type="date" v-model="startDate" class="form-control" />
        </div>
        <div class="col-md-6 float-left">
          <input type="date" v-model="endDate" class="form-control" />
        </div>
        <div class="col-md-12 mt-2 float-left text-center">
          <CButton size="sm" color="success" @click="getData()">Submit</CButton>
        </div>
        <div class="all float-left">
          <CDataTable
            v-if="data"
            :items="data"
            :fields="fields"
            column-filter
            table-filter
          >
          </CDataTable>
          <small-loader v-else-if="loading"></small-loader>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.getData = function () {
  this.loading = true
  const postData = {
    startDate: this.startDate,
    endDate: this.endDate
  }
  axios.post(this.$apiAdress + '/api/reports/getRepNumberOfOrdersTable?' + localStorage.getItem('api_token'), postData).then(response => {
    this.data = response.data
    this.loading = false
  })
}

export default {
  // ===Component name
  name: "RepNumberOfOrdersTable",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        data: null,
        startDate: '',
        endDate: '',
        fields: ['rep_name', 'rep_number', 'total'],
        loading: false
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    // this.getData()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
